module.exports = __webpack_public_path__ + "img/logo-coppersteel.63a7511.svg";